export enum ManageAutomationsTab {
  Automation = 0,
  Request = 1,
}
